<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Despesa, Cliente, NF..."
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">


          <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>

          <t-input-person supplier
                          v-model="form.supplierId" />

          <t-input-person creditor
                          v-model="form.supplierId" />


        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"

               link-primary-column="cashNumber"
               primary-key-column="cashNumber">

        <template #first-column="{item}">

          <t-list-link-primary formatter="lpad:4"
                               :label="item.cashNumber" :userAuth="userAuth" :id="item.cashNumber"
                               :path="currentPage.path"/>


        </template>



      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Revenue',
  data() {
    return {
      path: "financial/cash", //Utilizar somente quando fora do padrão
      form: {
        customerId: 0,
        companyId: 0,
        supplierId:0,
        chartAccountId:0,
        invoiceId:0,
        purchaseInvoiceId:0,
        typeCash:1,
        receiptNumber:0,
        issueDate: "",
        statusCash: 1,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      companyOptions: [],
      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {
      delete this.form.status
    },
    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.companyOptions = response.companyOptions
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()


  },
}
</script>
